import { baseApi } from "./baseApi";

const COC_COLLECTION_BASE_URL = "/cocCollections";

export const CocCollectionApi = baseApi.injectEndpoints({
  tagTypes: ["CocCollection"],
  endpoints: (builder) => ({

    createCocCollection: builder.mutation({
      query: (payload) => ({
        url: `${COC_COLLECTION_BASE_URL}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "CocCollection", id: "LIST" }],
    }),

    getCocCollectionList: builder.query({
      query: (params) => ({
        url: `${COC_COLLECTION_BASE_URL}`,
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
              ...result.data.map(({ _id }) => ({
                type: "CocCollection",
                id: _id,
              })),
              { type: "CocCollection", id: "LIST" },
            ]
          : [{ type: "CocCollection", id: "LIST" }],
    }),

    getCocCollectionListForVendor: builder.query({
      query: (params) => ({
        url: `${COC_COLLECTION_BASE_URL}/cocVendor`,
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
              ...result.data.map(({ _id }) => ({
                type: "CocCollection",
                id: _id,
              })),
              { type: "CocCollection", id: "LIST" },
            ]
          : [{ type: "CocCollection", id: "LIST" }],
    }),

    getCocCollectionDetail: builder.query({
      query: (id) => `${COC_COLLECTION_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "CocCollection", id },
        { type: "CocCollection", id: "LIST" },
      ],
    }),

    updateCocCollection: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;
        return {
          url: `${COC_COLLECTION_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "CocCollection", id: _id },
        { type: "CocCollection", id: "LIST" },
      ],
    }),

    addFinanceCollection: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${COC_COLLECTION_BASE_URL}/${id}/finance`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "CocCollection", id },
        { type: "CocCollection", id: "LIST" },
      ],
    }),

    rejectCOCCollection: builder.mutation({
      query: (id) => ({
        url: `${COC_COLLECTION_BASE_URL}/${id}/reject-collection`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "CocCollection", id },
        { type: "CocCollection", id: "LIST" },
      ],
    }),
    getCOCCollectionDDL: builder.query({
      query: (params) => {
        return { url: `${COC_COLLECTION_BASE_URL}/ddl`, params };
      },
    }),
    
    listShipmentsByCocCollectionId: builder.query({
      query: ({ codId, page, limit }) => ({
        url: `${COC_COLLECTION_BASE_URL}/${codId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "Consolidation", id: _id },
        { type: "Consolidation", id: "LIST" },
      ],
    }),

    downloadCocCollections: builder.query({
      query: (params) => ({
        url: `${COC_COLLECTION_BASE_URL}/download`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ cocCollectionId }) => ({
                type: "CocCollection",
                id: cocCollectionId,
              })),
              { type: "CocCollection", id: "LIST" },
            ]
          : [{ type: "CocCollection", id: "LIST" }],
      keepUnusedDataFor: 5,
    }),

    listCocCollectionBillingPrint: builder.query({
  query: ({ cocId, page, limit }) => ({
    url: `${COC_COLLECTION_BASE_URL}/${cocId}/billingPrint`,
    params: { page, limit },
  }),
  providesTags: (_result, _error, { _id }) => [
    { type: "CocCollection", id: _id },
    { type: "CocCollection", id: "LIST" },
  ],
    }),
    
  }),
});

export const {
  useGetCocCollectionListQuery,
  useLazyGetCocCollectionListQuery,
  useLazyGetCocCollectionListForVendorQuery,
  useGetCocCollectionDetailQuery,
  useCreateCocCollectionMutation,
  useUpdateCocCollectionMutation,
  useLazyGetCOCCollectionDDLQuery,
  useLazyListShipmentsByCocCollectionIdQuery,
  useAddFinanceCollectionMutation,
  useLazyDownloadCocCollectionsQuery,
  useRejectCOCCollectionMutation,
  useLazyListCocCollectionBillingPrintQuery,
} = CocCollectionApi;
